import { render } from "./UserNoticeHomes.vue?vue&type=template&id=68a5788e"
import script from "./UserNoticeHomes.vue?vue&type=script&lang=js"
export * from "./UserNoticeHomes.vue?vue&type=script&lang=js"

import exportComponent from "/home/sam/kenban_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__